import { all, fork } from 'redux-saga/effects'
import user from "./user"
import pageContent from "./pageContent"

export default function* watchers() {
  yield all([
    user,
    pageContent
  ].map(fork))
}